export async function fetchCreditBalance() {
  return { creditBalance: 0 };
}
export async function fetchSlidingCreditProducts() {
  return [];
}
export function getPendingCreditVerify() {
  return null;
}
export async function completePendingCreditVerify() {
  return { success: true };
}
export async function consumeCredits() {
  return { creditBalance: 0 };
}
